import { Info } from '@mui/icons-material';
import { Stack, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import { useLocation } from 'react-router-dom';

export enum MissingStateReasonEnum {
    EMPTY = 'EMPTY',
    ERROR = 'ERROR',
}

const defaultMessageKeys: Record<MissingStateReasonEnum, MessageDescriptor['id']> = {
    [MissingStateReasonEnum.EMPTY]: 'search.empty',
    [MissingStateReasonEnum.ERROR]: 'search.error',
};
const defaultColors: Record<MissingStateReasonEnum, 'disabled' | 'error'> = {
    [MissingStateReasonEnum.EMPTY]: 'disabled',
    [MissingStateReasonEnum.ERROR]: 'error',
};
const WATCHLIST_PATHNAME = '/activity/watchlist';
const WATCHLIST_EMPTY_MESSAGE_KEY = 'search.empty.watchlist';

interface EmptyStateProps {
    sx?: SxProps<Theme>;
    reason?: MissingStateReasonEnum;
    message?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ sx, reason = MissingStateReasonEnum.EMPTY, message }) => {
    const { pathname } = useLocation();
    const defaultMessageKey =
        pathname === WATCHLIST_PATHNAME && reason === MissingStateReasonEnum.EMPTY
            ? WATCHLIST_EMPTY_MESSAGE_KEY
            : defaultMessageKeys[reason];
    return (
        <Stack
            spacing={1}
            sx={{
                display: 'flex',
                flex: 1,
                height: '100%',
                width: '100%',
                alignItems: 'center',
                ...sx,
            }}
        >
            <Info color={defaultColors[reason]} />
            <Typography color="textSecondary" variant="caption">
                {message || <FormattedMessage id={defaultMessageKey} />}
            </Typography>
        </Stack>
    );
};
